// Modal pour iphone information
import React from 'react';
import './style/ReviewModal.css';
import { useTranslation } from 'react-i18next';

const InstallPromptModal = ({ onClose }) => {
  const { t } = useTranslation();

  return (
    <div className="review-modal-overlay">
      <div className="review-modal">
        <div className="review-modal-header">
          <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
            {t('InstallModal.device')}
          </span>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        <div>
          <p>📱 {t('InstallModal.title')}</p>
          <ul style={{ marginLeft: '1em' }}>
            <li>{t('InstallModal.step1')}</li>
            <li>{t('InstallModal.step2')}</li>
            <li>{t('InstallModal.step3')}</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default InstallPromptModal;
